var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.RetMsg)?_c('p',[_vm._v("出现错误："+_vm._s(_vm.RetMsg))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }